// extracted by mini-css-extract-plugin
module.exports = {"well":"admin_well__3p9Xi","stat-label":"admin_stat-label__3pQYl","stat-value":"admin_stat-value__1O0Tq"};